import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { routingListQuery } from "@/features/production/api";
import { validateVersionSearch, type VersionSearch } from "@/features/production/search";
import { VersionListPage } from "@/features/production/VersionListPage";
import { activeCompanyOf } from "@/lib/activeCompany";
import { sessionContextQuery } from "@/lib/session";
import { versionListColumns } from "@patronix/domain/list";
import { viewQuery } from "@/lib/listView";

export const Route = createFileRoute("/_app/manufacturing/routings")({
  validateSearch: validateVersionSearch,
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q, f: search.f, s: search.s }),
  loader: async ({ context, deps }) => {
    const ctx = await context.queryClient.ensureQueryData(sessionContextQuery);
    const companyId = activeCompanyOf(ctx)?.id;
    if (companyId) await context.queryClient.ensureInfiniteQueryData(routingListQuery(companyId, { status: deps.status, q: deps.q, ...viewQuery(versionListColumns, deps) }));
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<VersionSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <VersionListPage kind="routing" search={search} setSearch={setSearch} />;
}
